<a href="" [routerLink]="getRubricPageRouterLink(state?.rubric)" class="rubric-wrapper" [class.santa-pr-20]="!!state?.rubric?.color">
  <span class="rubric-label">
    {{ state?.rubric?.name }}
  </span>
  <span *ngIf="state?.rubric?.color" class="rubric-label-colored-dot" [style.background-color]="state?.rubric?.color"></span>
</a>
